<template>
  <div class="select_dialog_embed">
    <div class="proprietary_costs_embed_msg">
      <div class="select_dialog_embed_box" :class="{'w1000': showType === 'checkdetail'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--新增/修改财务账单-->
        <div v-if="showType === 'add' || showType === 'edit'" class="select_dialog_embed_box_content">
          <div>
            <div class="mt40 ml30 mb20">
              <span>提货信息：</span>
              <input class="inb" style="width: 260px;" type="text" v-model="pickUpMsg">
            </div>
            <div class="mt15 ml30">
              <span>提货日期：</span>
              <div class="inb" style="width: 282px">
                <el-date-picker
                  v-model.trim="pickUpTime"
                  type="date"
                  placeholder="年/月/日"
                  format="yyyy/MM/dd">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>

        <!--提交确认-->
        <div v-if="showType === 'submit'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb30">是否将当前数据提交审核？</p>
        </div>

        <!--撤回-->
        <div v-if="showType === 'revocation'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb30">是否将当前数据撤回上一个状态？</p>
        </div>

        <!--审核-->
        <div v-if="showType === 'check'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb30">是否将当前数据审核通过？</p>
        </div>

        <!--审核-->
        <div v-if="showType === 'delete'" class="select_dialog_embed_box_content">
          <p class="text_center mt30 mb30">是否将当前数据删除？</p>
        </div>

        <!--查看明细-->
        <div v-if="showType === 'checkdetail'" class="select_dialog_embed_box_content pl10 pr10">
          <div class="ml15 mt20 mb10">
            <button class="btn_normal mr15" @click="dialogVisible = true">导入明细</button>
            <span class="fcDel pl5 pt10 pr20 pb10" style="background-color: #eee">说明：每次导入将覆盖现有所有明细</span>
          </div>
          <table class="table">
            <thead>
            <tr>
              <th>货号</th>
              <th>尺码</th>
              <th>数量</th>
              <th>市场价</th>
              <th>成本折扣</th>
              <th>折扣单价</th>
              <th>成本金额</th>
              <th>销售折扣</th>
              <th>销售单价</th>
              <th>销售金额</th>
              <th>客户</th>
              <th>备注</th>
            </tr>
            </thead>
            <tbody v-if="detailList">
            <tr v-for="(item, index) in detailList" :key="index">
              <td>{{item.GoodsId}}</td>
              <td>{{item.SizeName}}</td>
              <td>{{item.Quantity}}</td>
              <td>{{item.MarketPrice}}</td>
              <td>{{item.CostDiscount}}</td>
              <td>{{item.DiscountUnitPrice}}</td>
              <td>{{item.CostAmount}}</td>
              <td>{{item.SellDiscount}}</td>
              <td>{{item.SellUnitPrice}}</td>
              <td>{{item.SellAmount}}</td>
              <td>{{item.ClientInfo}}</td>
              <td>{{item.Remark}}</td>
            </tr>
            </tbody>
            <tbody v-if="!detailList.length">
            <tr>
              <td colspan="12">暂无相关信息</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!--弹框上传文件-->
        <div v-if="dialogVisible" class="select_dialog_embed_box_content embed_dialog">
          <div>
            <input type="file" placeholder="选择文件" @change="tirggerFile($event)" accept=".xls,.xlsx">
            <button class="btn_normal ml150" @click="importFinanceDetailExcel()">上传</button>
            <button class="btn_normal" @click="getFinanceDetailImportExcelTemplet()">下载模板</button>
            <button class="btn_cancel" @click="dialogVisible=false">取消</button>
          </div>
        </div>

        <!--备注-->
        <div v-if="showType === 'remark'" class="select_dialog_embed_box_content" style="display: flex;">
          <span style="margin: 35px 25px;">备注：</span>
          <textarea style="width: 315px;height: 100px;margin: 20px 0;" maxlength="200" placeholder="最大只能输入200字" v-model="remark"></textarea>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb15">
          <button v-if="showType === 'submit'" class="btn_normal" @click="commitFinanceById()">确认</button>
          <button v-if="showType === 'revocation'" class="btn_normal" @click="revokeFinanceById()">确认</button>
          <button v-if="showType === 'check'" class="btn_normal" @click="checkFinanceById()">确认</button>
          <button v-if="showType === 'delete'" class="btn_normal" @click="deleteFinanceById()">确认</button>
          <button v-if="showType === 'import'" class="btn_normal" @click="submitBtn()">上传</button>
          <button v-if="showType === 'add' || showType === 'edit'" class="btn_normal" @click="saveFinanceStatement()">提交</button>
          <button v-if="showType === 'remark'" class="btn_normal" @click="remarkFinanceById()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false, false)">取消</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: "financial-billing-embed-msg",
    /**
     *  title：  头部名
     *  showType: 显示类型
     *  shopMsg: 店铺信息
     * */
    props: ['title', 'showType', 'msg'],
    components: {MsgDialog, LoadingDialog},
    data() {
      return {
        pickUpMsg: null, // 提货信息
        pickUpTime: null, // 提货时间
        remark: null, // 备注内容
        detailList: [], // 查看明细
        importFile: null, // 上传文件
        dialogVisible: false, // 组件弹框
        dialogTitle: '', // 弹出判断框头部
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 把财务单提交
      commitFinanceById() {
        this.$axios.post(this.Global.commitFinanceById(this.msg.FinanceId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 把财务单撤回
      revokeFinanceById() {
        this.$axios.post(this.Global.revokeFinanceById(this.msg.FinanceId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 把财务单审核
      checkFinanceById() {
        this.$axios.post(this.Global.checkFinanceById(this.msg.FinanceId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 删除财务单
      deleteFinanceById() {
        this.$axios.post(this.Global.deleteFinanceById(this.msg.FinanceId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 获取财务单明细数据
      getDetailsById() {
        this.$axios.post(this.Global.getDetailsById(this.msg.FinanceId), null).then((res) => {
          if (res) {
            if (!res.data.errorMsg.length) {
              this.detailList = res.data.resData;
            }
          }
          console.log(this.detailList);
        });
      },

      // 保存财务单信息
      saveFinanceStatement() {
        let financeId = null;
        if (this.msg) {
          financeId = this.msg.FinanceId;
        }
        const params = {
          FinanceId: financeId, // 新增传空，编辑传账单号
          TakeInfo: this.pickUpMsg,
          TakeTime: this.Global.timeFormatEightDate(this.pickUpTime)
        };
        this.$axios.post(this.Global.saveFinanceStatement, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 备注财务单
      remarkFinanceById() {
        this.$axios.post(this.Global.remarkFinanceById(this.msg.FinanceId, this.remark), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500)
        });
      },

      // 获取财务单明细导入模板
      getFinanceDetailImportExcelTemplet() {
        this.$axios.get(this.Global.getFinanceDetailImportExcelTemplet, null).then((res) => {
          if (res.data) {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          }
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 财务单明细导入【仅支持文件放在FormData方式上传】
      importFinanceDetailExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importFinanceDetailExcel(this.msg.FinanceId), formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                // self.importFile = null;
                self.dialogVisible=false;
                // window.open(res.data.resData, '_blank');
              } else if (res.data.resData) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = '文档有误，已下载';
                self.dialogVisible=false;
                // self.importFile = null;
                window.open(res.data.resData, '_blank');
              } else {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
                self.dialogVisible=false;
                // self.cancelBtn(true);
              }
            }
          }, 500);
        });
      },

      // 取消按钮
      cancelBtn(type) {
        this.isMsg = false;
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc && this.showType != 'checkdetail') {
          this.cancelBtn(true);
        } else {
          this.getDetailsById();
        }
      }

    },
    created() {
      if (this.showType == 'edit' && this.msg) {
        this.pickUpMsg=this.msg.TakeInfo;
        this.pickUpTime=this.msg.TakeTime;
      } else if (this.showType == 'remark') {
        this.remark = this.msg.Remark;
      } else if (this.showType == 'checkdetail') {
        this.getDetailsById();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .proprietary_costs_embed_msg{
    .select_dialog_embed_box {
      &.w1000 {
        width: 1000px;
        position: relative;

        .embed_dialog {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.4);
          display: flex;
          justify-content: center;
          align-items: center;

          &>div {
            background-color: #fff;
            width: 500px;
            height: 200px;

            input[type='file'] {
              display: inherit;
              margin: 50px;
            }
          }
        }
      }

      table {
        /*margin: 10px;*/
        /*width: calc(100% - 20px);*/

        th, td {
          border: 1px solid #ddd;
          max-width: 420px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/report-management/financial-billing-embed-msg.vue